import * as React from "react";
import "./InitPasswordPage.scss";
import SetPassword from "../components/password/SetPassword";
import Banner from "../components/banner/Banner";
/**
 * Stránka nastavení hesla po resetu.
 */

class PasswordChangePage extends React.Component<any> {
  handleLoginRedirect = () => {
    window.location.href = window.appConfig.serverContextPath + "/password-change/success";
  };

  render() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const code = urlParams.get("code");
    return(
      <>
          {typeof window !== "undefined" && window.appConfig?.isTST && (
              <Banner text="Testovací prostředí (TST)" />
          )}
          <SetPassword code={code} onLoginRedirect={this.handleLoginRedirect} />;
      </>
    )
  }
}

export default PasswordChangePage;
